import styled from "styled-components";

export const AppNotificationContainer = styled.div`
  width: 100%;

  background-color: ${({ theme }) => theme.notification.background};

  @media (max-width: 850px) {
    border-radius: 16px 16px 0px 0px;
  }

  .empty-message {
    text-align: center;
    margin: 1rem;
    color: ${({ theme }) => theme.notification.title};
  }

  .loader:not(svg) {
    margin: 1rem auto;
  }

  .loader {
    width: 18px;
    height: 18px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    border-bottom: 1px solid
      ${({ theme }) => theme.notification.contentBorderColor};
    color: ${({ theme }) => theme.notification.title};

    svg path {
      stroke: ${({ theme }) => theme.notification.title} !important;
    }

    button {
      padding: 0;
    }
  }

  ul {
    margin: 0;

    display: flex;
    flex-direction: column;
    gap: 1px;

    border-left: 2px solid transparent;

    max-height: 600px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 4px;
      display: block;
    }

    &::-webkit-scrollbar-track {
      width: 4px;
      display: block;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      display: block;
    }

    li {
      list-style: none;
    }
  }
`;
